import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import { EventNames, useTracking } from "lib/tracking";
import { SuggestedQuestion } from "./types";

type SuggestedQuestionProps = SuggestedQuestion & {
  resourceId: string;
  resourceName: string;
  onClick: () => void;
};

export default function AiChatSuggestedQuestionContainer({
  title,
  subtitle,
  prompt,
  resourceId,
  resourceName,
  onClick,
}: SuggestedQuestionProps) {
  const { logEvent } = useTracking();

  return (
    <Container
      onClick={() => {
        onClick();
        logEvent(EventNames.promptActioned, {
          "Prompt selection": prompt,
          "Input actioned": "Suggestion button",
          "Context source": "Ask AI",
          "Resource Id": resourceId,
          "Resource name": resourceName,
        });
      }}
    >
      <Flex column gap={4}>
        <Text bold>{title}</Text>
        <Text>{subtitle || prompt}</Text>
      </Flex>
    </Container>
  );
}

const Container = styled.div(({ theme }) => ({
  padding: "12px 16px",
  border: `1px solid ${theme.colors.sysBorderDecorative}`,
  borderRadius: 8,
  cursor: "pointer",
  ":hover": {
    color: theme.colors.sysTextDefault,
    backgroundColor: theme.colors.sysPrimarySubtle,
    borderColor: theme.colors.sysPrimaryHover,
  },
}));
